import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import { useAuth } from '../context/AuthContext'
import { getCrmSyncPostPath } from '../lib/crmSync'
import { isSupabaseAuth } from '../lib/supabase'
import { Alert, FormField } from './ui'
import { btn, cardClass, cn, formActionsClass, formGridClass, inputClass } from '../lib/ui'
import { pocketbaseErrorMessage } from '../lib/pocketbaseErrorMessage'

type LoginCardProps = {
  /** Куда перейти после успешного входа */
  afterLoginTo: string
  /** Показать ссылку «На главную» (для отдельного маршрута `/login`) */
  showHomeLink?: boolean
}

export function LoginCard({ afterLoginTo, showHomeLink }: LoginCardProps) {
  const { login, loading } = useAuth()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [err, setErr] = useState('')
  const [busy, setBusy] = useState(false)

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault()
    setErr('')
    setBusy(true)
    try {
      await login(email.trim(), password)
      navigate(afterLoginTo, { replace: true })
    } catch (e: unknown) {
      setErr(pocketbaseErrorMessage(e, 'Ошибка входа'))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className={cn(cardClass, 'w-full max-w-sm px-8 py-8')}>
      <h1 className="m-0 mb-1.5 text-[1.35rem] font-bold tracking-tight text-su-text-strong">Вход в СУП</h1>
      <p className="mb-4 text-[0.85rem] leading-snug text-slate-500">
        {isSupabaseAuth()
          ? getCrmSyncPostPath()
            ? 'Вход через CRM (Supabase); учётная запись для доступа к данным СУП синхронизируется автоматически перед входом.'
            : 'Вход через CRM (Supabase); если сервис синхронизации не включён — пара email/пароль должна совпадать с записью employees в базе производства.'
          : 'Учётная запись сотрудника (коллекция employees в PocketBase производства).'}
      </p>
      {err && <Alert kind="err">{err}</Alert>}
      <form onSubmit={(e) => void onSubmit(e)} className={formGridClass}>
        <FormField label="Email" htmlFor="login-email">
          <input
            id="login-email"
            type="email"
            autoComplete="username"
            className={inputClass}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </FormField>
        <FormField label="Пароль" htmlFor="login-password">
          <input
            id="login-password"
            type="password"
            autoComplete="current-password"
            className={inputClass}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </FormField>
        <div className={formActionsClass}>
          <button type="submit" className={btn('primary')} disabled={busy || loading}>
            {busy ? 'Вход…' : 'Войти'}
          </button>
          {showHomeLink && (
            <Link to="/" className={btn('ghost')}>
              На главную
            </Link>
          )}
        </div>
      </form>
    </div>
  )
}
